import {ColorsActionTypes} from "./types";

export interface ColorsState {
    cardColor: string
    textColor: string
    mutedColor: string
    bg: string
    fg: string
    colorNombre: string
    colorNumero: string
    colorClases: string
    colorVigencia: string
    colorBoton: string
    colorBorderBoton: string
    colorBorder: string
    colorBotonBg: string
    colorMe: string
    colorCs: string
    colorDs: string
    colorCa:string
    colorTa:string
    colorClass: string
    text: string
    updated: boolean
}

export interface ColorAction {
    type: ColorsActionTypes;
    payload: ColorsState;
}

export const updateColors = (data: any) => {
    return {
        type: ColorsActionTypes.UPDATE,
        payload: data
    }
}